module.exports = __webpack_public_path__ + "img/020-chat.956777dd.svg";